import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {CustomerModel} from '../models/customer.model';
import {LokijsService} from './database/lokijs.service';
import {HrateModel} from '../models/hrate.model';
import {ChargeLineDTOModel} from '../models/charge-lineDTO.model';
import {StateManagerService} from './state-manager.service';

@Injectable({
    providedIn: 'root'
})
export class FindEquipmentPriceService {

    constructor(private lokiJs: LokijsService,
                private stateManager: StateManagerService) {
    }

    getPriceSync(equip: DetaillineDTOModel, cust: CustomerModel): HrateModel[] {
        // Fetches the Hrate related to pro equipment passed as parameter
        console.log(equip);
        if (cust.tender) {
            let currentHrate: HrateModel[] = this.stateManager.getCollection('hrates');
            currentHrate = currentHrate.filter(hRate => {
                return hRate.pdesc === equip.pdesc && hRate.tender === cust.tender;
            });
            // If the price was found, happy days, return.
            if (currentHrate.length > 0) {
                return currentHrate;
            } else {
                // Fetches the pricelist for the given customer to query if there's a parent
                let currentPriceList = this.stateManager.getCollection('pricelist');
                currentPriceList = currentPriceList.filter(priceList => {
                    return priceList.cod === cust.tender;
                });
                if (currentPriceList[0].parent) {
                    currentHrate = this.stateManager.getCollection('hrates');
                    currentHrate = currentHrate.filter(hRate => {
                        return hRate.pdesc === equip.pdesc && hRate.tender === currentPriceList[0].parent.cod;
                    });
                    if (currentHrate.length > 0) {
                        return currentHrate;
                    }
                }
                if (currentHrate.length <= 0) {
                    currentHrate = this.stateManager.getCollection('hrates');
                    currentHrate = currentHrate.filter(hRate => {
                        return hRate.pdesc === equip.pdesc && hRate.tender === 'STANDARD';
                    });
                    return currentHrate;
                }
            }
        } else {
            let currentHrate = this.stateManager.getCollection('hrates');
            currentHrate = currentHrate.filter(hRate => {
                return hRate.pdesc === equip.pdesc && hRate.tender === 'STANDARD';
            });
            return currentHrate;
        }
    }

    async getPrice(equip: DetaillineDTOModel, cust: CustomerModel): Promise<HrateModel[]> {
        // Fetches the Hrate related to pro equipment passed as parameter
        console.log(equip);
        if (cust.tender) {
            let currentHrate: HrateModel[] = await this.lokiJs.getTable('hrates', 'id')
                .chain().find({pdesc: equip.pdesc, tender: cust.tender}).data();
            // If the price was found, happy days, return.
            if (currentHrate.length > 0) {
                return currentHrate;
            } else {
                // Fetches the pricelist for the given customer to query if there's a parent
                const currentPriceList = await this.lokiJs.getTable('pricelist', 'nsuk')
                    .chain().find({cod: cust.tender}).data();
                if (currentPriceList[0].parent) {
                    currentHrate = await this.lokiJs.getTable('hrates', 'id')
                        .chain().find({pdesc: equip.pdesc, tender: currentPriceList[0].parent.cod}).data();
                    if (currentHrate.length > 0) {
                        return currentHrate;
                    }
                }
                if (currentHrate.length <= 0) {
                    currentHrate = await this.lokiJs.getTable('hrates', 'id')
                        .chain().find({pdesc: equip.pdesc, tender: 'STANDARD'}).data();
                    return currentHrate;
                }
            }
        } else {
            const currentHrate = await this.lokiJs.getTable('hrates', 'id')
                .chain().find({pdesc: equip.pdesc, tender: 'STANDARD'}).data();
            return currentHrate;
        }
    }

    async isDiscountable(tender: string) {
        const pricelist = await this.lokiJs.getTable('pricelist', 'nsuk')
            .chain().find({cod: tender}).data();
        return pricelist[0].discountable;
    }

    isDiscountableSync(tender: string) {
        let pricelist = this.stateManager.getCollection('pricelist');
        pricelist = pricelist.filter(pList => {
            return pList.cod === tender;
        });
        return pricelist[0].discountable;
    }

    async getDiscount(cust: CustomerModel, tender?: string) {
        if (tender) {
            await this.isDiscountable(tender).then(res => {
                if (res === 0) {
                    return 0;
                } else {
                    return cust.hireDisc;
                }
            });
        } else {
            await this.isDiscountable(cust.tender).then(res => {
                if (res === 0) {
                    return 0;
                } else {
                    return cust.hireDisc;
                }
            });
        }
        return 0;
    }

    addChargeLine(hrate: HrateModel): ChargeLineDTOModel {
        const chargeLine = new ChargeLineDTOModel();
        chargeLine.day1 = hrate.day1;
        chargeLine.day2 = hrate.day2;
        chargeLine.day3 = hrate.day3;
        chargeLine.day4 = hrate.day4;
        chargeLine.day5 = hrate.day5;
        chargeLine.day6 = hrate.day6;
        chargeLine.halfDay = hrate.halfDay;
        chargeLine.hr = hrate.hour;
        chargeLine.minCharge = hrate.minCharge;
        chargeLine.same = hrate.same;
        chargeLine.week = hrate.week;

        return chargeLine;
    }

    getChargeLineAndDiscount(tempEquip: DetaillineDTOModel, customer: CustomerModel): DetaillineDTOModel {
        const res = this.getPriceSync(tempEquip, customer);
        console.log(res);
        const equip = JSON.parse(JSON.stringify(res[0]));
        console.log(equip);
        if (equip.pdesc === tempEquip.pdesc) {
            const result = this.isDiscountableSync(equip.tender);
            console.log(result);
            if (result === 1) {
                tempEquip.discount = customer.hireDisc;
            } else {
                tempEquip.discount = 0;
            }
            tempEquip.weeklyRate = equip.week;
            tempEquip.chargeLine = this.addChargeLine(equip);
            tempEquip.overrideDescriptionNote = tempEquip.description;
        } else {
            tempEquip.discount = 0;
        }
        return tempEquip;
    }
}
